export default __webpack_public_path__ + "static/media/bannersweb_hotsale_1_moto_330x330.1c9cdb41.png";